import { type SupplierFacility } from '@frontend/api';

import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_SUPPLIER_FACILITY_ERROR:
    'common/supplierFacilitySelector/FETCH_SUPPLIER_FACILITY_ERROR',
  FETCH_SUPPLIER_FACILITY_REQUEST:
    'common/supplierFacilitySelector/FETCH_SUPPLIER_FACILITY_REQUEST',
  FETCH_SUPPLIER_FACILITY_SUCCESS:
    'common/supplierFacilitySelector/FETCH_SUPPLIER_FACILITY_SUCCESS',
} as const;

export const fetchSupplierFacilities = {
  request: () => ({
    type: types.FETCH_SUPPLIER_FACILITY_REQUEST,
  }),
  success: ({
    supplierFacilities,
  }: {
    supplierFacilities: SupplierFacility[];
  }) => ({
    type: types.FETCH_SUPPLIER_FACILITY_SUCCESS,
    payload: { supplierFacilities },
  }),
  error: notify(
    (error) => ({
      type: types.FETCH_SUPPLIER_FACILITY_ERROR,
      payload: error,
    }),
    "Can't fetch supplier facilities",
  ),
};
